<div
     snAssistantSurface="webhook"
     i18n-surfaceTitle="@@webhook.surface"
     surfaceTitle="Webhook" class="webhook-edit-container">
  <div class="webhook-top-panel">
    <div class="top-panel-container">
      <div class="panel-left-section">
        <p-breadcrumb
          [model]="breadcrumbItems()"
          styleClass="custom-breadcrumb compact-breadcrumb"
          [style]="{'--p-breadcrumb-padding': '0', '--p-breadcrumb-item-hover-color': 'var(--p-primary-color)'}">
        </p-breadcrumb>
      </div>
      <div class="panel-right-section">
        <p-button
          i18n-label="@@webhookEdit.backToDevelopers"
          label="Back to Developers"
          icon="pi pi-arrow-left"
          severity="secondary"
          [outlined]="true"
          size="small"
          (click)="onCancel()">
        </p-button>
      </div>
    </div>
  </div>

  <div class="webhook-edit-page-container">
    <p-card class="webhook-edit-card">
      <div class="header-section">
        <h2>{{ headerTitle }}</h2>
        <p class="header-description" i18n="@@webhookEdit.headerDescription">Configure a webhook to receive event notifications.</p>
      </div>

      @if (isLoading()) {
        <div class="loading-container">
          <p-progressSpinner strokeWidth="3" [style]="{'width': '50px', 'height': '50px'}"></p-progressSpinner>
          <p i18n="@@webhookEdit.loading">Loading webhook...</p>
        </div>
      }

      @if (!isLoading()) {
        <div class="webhook-form-container">
          <!-- URL -->
          <div class="form-field">
            <label class="field-label">URL *</label>
            <p class="field-description" i18n="@@webhookEdit.url.description">The endpoint URL that will receive webhook events.</p>
            <input
              [snAssistantId]="F.url"
              pInputText
              name="url"
              [(ngModel)]="url"
              placeholder="https://example.com/webhooks"
              class="w-full">
          </div>

          <!-- Description -->
          <div class="form-field">
            <label class="field-label" i18n="@@webhookTool.description.label">Description</label>
            <p class="field-description" i18n="@@webhookEdit.description.description">Optional description of this webhook's purpose.</p>
            <textarea
              [snAssistantId]="F.description"
              pTextarea
              name="description"
              [(ngModel)]="description"
              i18n-placeholder="@@webhookEdit.description.placeholder"
              placeholder="e.g., Send conversation data to CRM"
              rows="2"
              [autoResize]="true"
              class="w-full">
            </textarea>
          </div>

          <!-- Event Types -->
          <div class="form-field">
            <label class="field-label" i18n="@@webhookEdit.eventTypes.label">Event Types</label>
            <p class="field-description" i18n="@@webhookEdit.eventTypes.description">Select which events should trigger this webhook.</p>
            <div class="event-toggles">
              @for (eventType of availableEventTypes; track eventType) {
                <div class="event-toggle-item">
                  <div class="event-toggle-content">
                    <span class="event-toggle-label">{{ eventTypeMap[eventType].label }}</span>
                    <span class="event-toggle-description">{{ eventTypeMap[eventType].description }}</span>
                  </div>
                  <p-toggleSwitch
                    [ngModel]="isEventSelected(eventType)"
                    (ngModelChange)="toggleEvent(eventType)">
                  </p-toggleSwitch>
                </div>
              }
            </div>
          </div>

          <!-- Agent filter -->
          <div class="form-field">
            <div class="switch-field">
              <div class="switch-content">
                <label class="switch-label" i18n="@@webhookEdit.onlySpecifiedAgents.label">Only specified agents</label>
                <p class="field-description" i18n="@@webhookEdit.onlySpecifiedAgents.description">
                  Off — events of every agent in the workspace are sent. On — only events of the agents you pick below.
                </p>
              </div>
              <p-toggleSwitch
                [snAssistantId]="F.onlySpecifiedAgents"
                name="only_specified_agents"
                [(ngModel)]="onlySpecifiedAgents"></p-toggleSwitch>
            </div>
          </div>

          @if (onlySpecifiedAgents()) {
            <div class="form-field">
              <label class="field-label" i18n="@@webhookEdit.agents.label">Agents</label>
              <p class="field-description" i18n="@@webhookEdit.agents.description">Events of these agents are delivered; everything else is skipped.</p>
              <p-multiSelect
                [snAssistantId]="F.agentIds"
                name="agent_ids"
                [(ngModel)]="agentIds"
                [options]="agentOptions()"
                optionLabel="label"
                optionValue="value"
                [filter]="true"
                display="chip"
                i18n-placeholder="@@webhookEdit.agents.placeholder"
                placeholder="Select agents"
                i18n-filterPlaceHolder="@@common.search"
                filterPlaceHolder="Search"
                i18n-emptyMessage="@@webhookEdit.agents.empty"
                emptyMessage="No agents yet"
                styleClass="w-full" />

              @if (noAgentsPicked()) {
                <small class="field-warning" i18n="@@webhookEdit.agents.noneSelected">
                  Nothing is selected, so this webhook will receive nothing. Pick an agent or turn the switch off.
                </small>
              }

              @if (droppedAgentCount(); as dropped) {
                <small class="field-warning" i18n="@@webhookEdit.agents.dropped">
                  {{ dropped }} previously selected agent(s) no longer exist and were removed from the list. Save to apply.
                </small>
              }

              @if (unfilterableEventLabels(); as unfilterable) {
                <small class="field-warning" i18n="@@webhookEdit.agents.unfilterableEvents">
                  These events are not tied to an agent and are delivered regardless of this filter: {{ unfilterable }}.
                </small>
              }
            </div>
          }

          <p-divider></p-divider>

          <!-- Enabled -->
          <div class="form-field">
            <div class="switch-field">
              <div class="switch-content">
                <label class="switch-label" i18n="@@webhookEdit.enabled.label">Enabled</label>
                <p class="field-description" i18n="@@webhookEdit.enabled.description">When disabled, webhook will not receive any events.</p>
              </div>
              <p-toggleSwitch
 [snAssistantId]="F.enabled" name="enabled"
 [(ngModel)]="enabled"></p-toggleSwitch>
            </div>
          </div>

          <!-- Secret (edit mode only) -->
          @if (isEditMode && secret()) {
            <div class="form-field">
              <label class="field-label" i18n="@@webhookEdit.secret.label">Secret</label>
              <p class="field-description" i18n="@@webhookEdit.secret.description">
                Use this secret to verify webhook signatures. Each request includes an
                <code>X-Webhook-Signature</code> header containing an HMAC-SHA256 hash of the request body.
              </p>
              <div class="secret-display">
                <code class="secret-value">{{ secret() }}</code>
                <p-button
                  icon="pi pi-copy"
                  severity="secondary"
                  [outlined]="true"
                  size="small"
                  (click)="copySecret()"
                  i18n-pTooltip="@@common.copyToClipboard"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="left"
                  i18n-ariaLabel="@@common.copyToClipboard"
                  ariaLabel="Copy to clipboard">
                </p-button>
              </div>
            </div>
          }
        </div>

        <!-- Action Buttons -->
        <div class="action-buttons">
          <p-button
            type="button"
            i18n-label="@@common.cancel"
            label="Cancel"
            severity="secondary"
            [outlined]="true"
            (click)="onCancel()"
            icon="pi pi-arrow-left">
          </p-button>
          <p-button
            type="button"
            [label]="saveBtnLabel"
            snAssistantAction="save"
            actionHint="Saves the webhook."
            (click)="onSave()"
            [icon]="isSaving() ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
            [disabled]="isSaving()"
            [loading]="isSaving()">
          </p-button>
        </div>
      }
    </p-card>
  </div>
</div>
